import {
  RESTAURANT_WIZARD_STEP_ORDER,
  RestaurantWizardStep,
  RestaurantWizardSteps
} from '../../../constants/RestaurantWizardConstants';
import { PAGE_CREATE_RESTAURANT, PAGE_EDIT_RESTAURANT } from '../../../constants/UriConstants';

export const getNextStep = (currentStep: RestaurantWizardStep): RestaurantWizardStep | null => {
  const index = RESTAURANT_WIZARD_STEP_ORDER.indexOf(currentStep);
  if (index < 0 || index >= RESTAURANT_WIZARD_STEP_ORDER.length - 1) {
    return null;
  }
  return RESTAURANT_WIZARD_STEP_ORDER[index + 1];
};

export const getPreviousStep = (currentStep: RestaurantWizardStep): RestaurantWizardStep | null => {
  const index = RESTAURANT_WIZARD_STEP_ORDER.indexOf(currentStep);
  if (index <= 0) {
    return null;
  }
  return RESTAURANT_WIZARD_STEP_ORDER[index - 1];
};

export const getWizardBasePath = (isEdit: boolean) =>
  isEdit ? PAGE_EDIT_RESTAURANT : PAGE_CREATE_RESTAURANT;

export const getWizardStepPath = (isEdit: boolean, step: RestaurantWizardStep) =>
  `/${getWizardBasePath(isEdit)}/${step}`;

export const getCreateRestaurantPath = () => getWizardStepPath(false, RestaurantWizardSteps.BASIC);

export { RestaurantWizardSteps };
